"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CustomFields = _interopRequireDefault(require("../CustomFields"));
var styles = {
  "overview": "overview_2o8OGT",
  "data-table": "data-table_2PMMk9",
  "dataTable": "data-table_2PMMk9"
}; 
require('./BaseOverview.css');
var BaseOverview = function BaseOverview(_ref) {
  var asset = _ref.asset,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: styles.overview,
    "data-test-id": "overview",
    "aria-label": "Asset overview"
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: styles.dataTable
  }, /*#__PURE__*/_react.default.createElement("tbody", null, children), /*#__PURE__*/_react.default.createElement("caption", {
    className: "visually-hidden"
  }, "Asset overview")), /*#__PURE__*/_react.default.createElement(_CustomFields.default, {
    customFields: asset.customFields
  }));
};
var _default = exports.default = BaseOverview;
//# sourceMappingURL=BaseOverview.js.map